import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Container } from '@/components/ui/Container'
import { buttonVariants } from '@/components/ui/Button'
import { siteConfig } from '@/config/site'

export function HeroSection() {
  return (
    <section className="relative min-h-[calc(100svh-3.75rem)] flex items-center justify-center py-12 sm:py-20 md:py-28 overflow-hidden bg-surface-0">
      {/* Architectural subtle background grid */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03] dark:opacity-[0.05] bg-[radial-gradient(var(--border-strong)_1px,transparent_1px)] [background-size:24px_24px]"
        aria-hidden="true"
      />

      <Container className="relative z-10 text-center max-w-4xl">
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-fg text-balance leading-[1.15]">
          Building Software{' '}
          <br className="hidden sm:inline" />
          That Stands Above.
        </h1>

        <p className="mt-4 sm:mt-6 text-sm sm:text-lg md:text-xl text-fg-subtle max-w-2xl mx-auto text-pretty leading-relaxed">
          {siteConfig.description}
        </p>

        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 w-full max-w-xs sm:max-w-none mx-auto">
          <Link
            to="/contact"
            className={buttonVariants({ variant: 'primary', size: 'lg' })}
          >
            <span>Get a Free Quote</span>
            <ArrowRight size={16} />
          </Link>

          <Link
            to="/services"
            className={buttonVariants({ variant: 'outline', size: 'lg' })}
          >
            Explore Services
          </Link>
        </div>
      </Container>
    </section>
  )
}
